import React from 'react';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { HeadingWithBody, TileSelect } from '@99designs/spa-common';
import { Answer } from '../../components/Step/Answer';
import type { StepComponentProps, StepHeadingProps } from '../../components/Onboarder/Config';
import type { Data } from '../config';

export type StakeholderValue = 'myself' | 'client';

export function StakeholderStepInputs({ data, onChange }: StepComponentProps<Data>) {
    return (
        <TileSelect<StakeholderValue>
            name="stakeholder"
            value={data.stakeholder}
            options={[
                {
                    label: (
                        <HeadingWithBody
                            heading={__('Myself')}
                            body={__('a business or project I run')}
                        />
                    ),
                    value: 'myself',
                },
                {
                    label: (
                        <HeadingWithBody
                            heading={__('Someone else')}
                            body={__('a client or business that I work for')}
                        />
                    ),
                    value: 'client',
                },
            ]}
            onChange={(value, name) => {
                const newData: Data = {
                    ...data,
                    [name]: value,
                };
                onChange(newData);
            }}
        />
    );
}

export const answerCopy = (): { [key: string]: string } => ({
    myself: __('myself'),
    client: __(' someone else'),
});

export const questionCopy = () => __('I am creating this website for {answer}');

export function StakeholderStepHeading({ data }: StepHeadingProps<Data>) {
    const answer = data.stakeholder ? answerCopy()[data.stakeholder] : '';

    return (
        <FormattedMessage message={questionCopy()} values={{ answer: <Answer text={answer} /> }} />
    );
}
